/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddContributorRequest,
  ApplicationScope,
  Database,
  DatabaseContentPage,
  DatabaseContributor,
  DatabaseEmailTemplate,
  DatabaseEmailTemplateSpecification,
  DatabaseEntry,
  DatabaseEntryFileMetaData,
  DatabaseEntryUpdateCreate,
  DatabaseField,
  DatabasePages,
  DatabasePermissionMatrix,
  DatabasesQuota,
  SetAnonymousPasswordRequest,
  UpdateContributorRequest,
  UpdateFieldRequest,
  VorlagenwechselAuftrag,
  VorlagenwechselBericht,
  VorlagenwechselZuordnung,
} from '../models';
import {
    AddContributorRequestFromJSON,
    AddContributorRequestToJSON,
    ApplicationScopeFromJSON,
    ApplicationScopeToJSON,
    DatabaseFromJSON,
    DatabaseToJSON,
    DatabaseContentPageFromJSON,
    DatabaseContentPageToJSON,
    DatabaseContributorFromJSON,
    DatabaseContributorToJSON,
    DatabaseEmailTemplateFromJSON,
    DatabaseEmailTemplateToJSON,
    DatabaseEmailTemplateSpecificationFromJSON,
    DatabaseEmailTemplateSpecificationToJSON,
    DatabaseEntryFromJSON,
    DatabaseEntryToJSON,
    DatabaseEntryFileMetaDataFromJSON,
    DatabaseEntryFileMetaDataToJSON,
    DatabaseEntryUpdateCreateFromJSON,
    DatabaseEntryUpdateCreateToJSON,
    DatabaseFieldFromJSON,
    DatabaseFieldToJSON,
    DatabasePagesFromJSON,
    DatabasePagesToJSON,
    DatabasePermissionMatrixFromJSON,
    DatabasePermissionMatrixToJSON,
    DatabasesQuotaFromJSON,
    DatabasesQuotaToJSON,
    SetAnonymousPasswordRequestFromJSON,
    SetAnonymousPasswordRequestToJSON,
    UpdateContributorRequestFromJSON,
    UpdateContributorRequestToJSON,
    UpdateFieldRequestFromJSON,
    UpdateFieldRequestToJSON,
    VorlagenwechselAuftragFromJSON,
    VorlagenwechselAuftragToJSON,
    VorlagenwechselBerichtFromJSON,
    VorlagenwechselBerichtToJSON,
    VorlagenwechselZuordnungFromJSON,
    VorlagenwechselZuordnungToJSON,
} from '../models';

export interface AddContributorOperationRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
    addContributorRequest?: AddContributorRequest;
}

export interface CopyDatabaseRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
}

export interface CreateContentPageRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
    databaseContentPage?: DatabaseContentPage;
}

export interface CreateDatabaseRequest {
    xApplicationScope: ApplicationScope;
    database: Database;
    templateId?: string;
}

export interface CreateDatabaseAttachmentRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
    databaseEntryFileMetaData?: DatabaseEntryFileMetaData;
}

export interface CreateEntryAsAdminRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
    databaseEntryUpdateCreate: DatabaseEntryUpdateCreate;
}

export interface CreateFieldRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
    databaseField: DatabaseField;
}

export interface DeleteAllDatabaseEntriesRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
}

export interface DeleteContentPageRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
    pageId: string;
}

export interface DeleteContributorRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
    customerId: string;
}

export interface DeleteDatabaseRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
}

export interface DeleteDatabaseAsSuperadminRequest {
    xApplicationScope: ApplicationScope;
    customerId: string;
    databaseId: string;
}

export interface DeleteDatabaseAttachmentRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
    attachmentId: string;
}

export interface DeleteFieldRequest {
    xApplicationScope: ApplicationScope;
    fieldId: string;
    databaseId: string;
}

export interface DownloadDatabaseFilesRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
}

export interface GetContributorsRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
}

export interface GetDatabaseAsExcelRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
}

export interface GetDatabaseChildrenForAdminRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
}

export interface GetDatabaseForAdminRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
}

export interface GetDatabasesRequest {
    xApplicationScope: ApplicationScope;
}

export interface GetFieldRequest {
    xApplicationScope: ApplicationScope;
    fieldId: string;
    databaseId: string;
}

export interface GetFieldsRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
}

export interface GetMailTemplateDefaultRequest {
    xApplicationScope: ApplicationScope;
    templateType: DatabaseEmailTemplate;
}

export interface GetMailTemplatesRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
}

export interface GetPermissionsRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
}

export interface GetQuotaRequest {
    xApplicationScope: ApplicationScope;
}

export interface GetQuotaAsSuperadminRequest {
    xApplicationScope: ApplicationScope;
    customerId: string;
}

export interface ImportExcelToDatabaseRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
    body?: Blob;
}

export interface PartiallyUpdateDatabaseRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
    database?: Database;
}

export interface SendDatedEmailsRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
}

export interface SetAnonymousPasswordOperationRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
    setAnonymousPasswordRequest?: SetAnonymousPasswordRequest;
}

export interface SetDefaultAnonymousPasswordRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
}

export interface SetMailTemplatesRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
    databaseEmailTemplateSpecification: Array<DatabaseEmailTemplateSpecification>;
}

export interface ToggleDatabaseAdminLockRequest {
    xApplicationScope: ApplicationScope;
    customerId: string;
    databaseId: string;
}

export interface ToggleDatabaseLockRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
}

export interface UpdateContentPageRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
    pageId: string;
    databaseContentPage?: DatabaseContentPage;
}

export interface UpdateContentPagesOrderRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
    requestBody: Array<string>;
}

export interface UpdateContributorOperationRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
    customerId: string;
    updateContributorRequest?: UpdateContributorRequest;
}

export interface UpdateDatabaseAttachmentRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
    attachmentId: string;
    databaseEntryFileMetaData: DatabaseEntryFileMetaData;
}

export interface UpdateFieldOperationRequest {
    xApplicationScope: ApplicationScope;
    fieldId: string;
    databaseId: string;
    updateFieldRequest?: UpdateFieldRequest;
}

export interface UpdateFieldsOrderRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
    requestBody: Array<string>;
}

export interface UpdatePagesRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
    databasePages?: DatabasePages;
}

export interface UpdatePermissionsRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
    databasePermissionMatrix?: DatabasePermissionMatrix;
}

export interface VorlagenwechselAusfuehrenRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
    vorlagenwechselAuftrag: VorlagenwechselAuftrag;
}

export interface VorlagenwechselVorschauRequest {
    xApplicationScope: ApplicationScope;
    databaseId: string;
    zielVorlageId: string;
}

/**
 * 
 */
export class DatabaseAdminControllerApi extends runtime.BaseAPI {

    /**
     * add database contributor
     * add database contributor
     */
    async addContributorRaw(requestParameters: AddContributorOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DatabaseContributor>>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling addContributor.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling addContributor.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dbadmin/databases/{databaseId}/contributors`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddContributorRequestToJSON(requestParameters.addContributorRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DatabaseContributorFromJSON));
    }

    /**
     * add database contributor
     * add database contributor
     */
    async addContributor(requestParameters: AddContributorOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DatabaseContributor>> {
        const response = await this.addContributorRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * database gets copied
     * copys the database
     */
    async copyDatabaseRaw(requestParameters: CopyDatabaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Database>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling copyDatabase.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling copyDatabase.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dbadmin/databases/{databaseId}/copy`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DatabaseFromJSON(jsonValue));
    }

    /**
     * database gets copied
     * copys the database
     */
    async copyDatabase(requestParameters: CopyDatabaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Database> {
        const response = await this.copyDatabaseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * create content page
     * Create content page
     */
    async createContentPageRaw(requestParameters: CreateContentPageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DatabaseContentPage>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling createContentPage.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling createContentPage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dbadmin/databases/{databaseId}/content-pages`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DatabaseContentPageToJSON(requestParameters.databaseContentPage),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DatabaseContentPageFromJSON(jsonValue));
    }

    /**
     * create content page
     * Create content page
     */
    async createContentPage(requestParameters: CreateContentPageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DatabaseContentPage> {
        const response = await this.createContentPageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * create a database
     * create a database
     */
    async createDatabaseRaw(requestParameters: CreateDatabaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Database>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling createDatabase.');
        }

        if (requestParameters.database === null || requestParameters.database === undefined) {
            throw new runtime.RequiredError('database','Required parameter requestParameters.database was null or undefined when calling createDatabase.');
        }

        const queryParameters: any = {};

        if (requestParameters.templateId !== undefined) {
            queryParameters['templateId'] = requestParameters.templateId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dbadmin/databases`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DatabaseToJSON(requestParameters.database),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DatabaseFromJSON(jsonValue));
    }

    /**
     * create a database
     * create a database
     */
    async createDatabase(requestParameters: CreateDatabaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Database> {
        const response = await this.createDatabaseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * create database attachment
     * Create database attachment
     */
    async createDatabaseAttachmentRaw(requestParameters: CreateDatabaseAttachmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DatabaseEntryFileMetaData>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling createDatabaseAttachment.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling createDatabaseAttachment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dbadmin/{databaseId}/attachments`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DatabaseEntryFileMetaDataToJSON(requestParameters.databaseEntryFileMetaData),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DatabaseEntryFileMetaDataFromJSON(jsonValue));
    }

    /**
     * create database attachment
     * Create database attachment
     */
    async createDatabaseAttachment(requestParameters: CreateDatabaseAttachmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DatabaseEntryFileMetaData> {
        const response = await this.createDatabaseAttachmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * create an entry as admin (bypasses ownership check)
     * create an entry as admin (bypasses ownership check)
     */
    async createEntryAsAdminRaw(requestParameters: CreateEntryAsAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DatabaseEntry>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling createEntryAsAdmin.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling createEntryAsAdmin.');
        }

        if (requestParameters.databaseEntryUpdateCreate === null || requestParameters.databaseEntryUpdateCreate === undefined) {
            throw new runtime.RequiredError('databaseEntryUpdateCreate','Required parameter requestParameters.databaseEntryUpdateCreate was null or undefined when calling createEntryAsAdmin.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dbadmin/databases/{databaseId}/entries`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DatabaseEntryUpdateCreateToJSON(requestParameters.databaseEntryUpdateCreate),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DatabaseEntryFromJSON(jsonValue));
    }

    /**
     * create an entry as admin (bypasses ownership check)
     * create an entry as admin (bypasses ownership check)
     */
    async createEntryAsAdmin(requestParameters: CreateEntryAsAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DatabaseEntry> {
        const response = await this.createEntryAsAdminRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * create a field
     */
    async createFieldRaw(requestParameters: CreateFieldRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DatabaseField>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling createField.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling createField.');
        }

        if (requestParameters.databaseField === null || requestParameters.databaseField === undefined) {
            throw new runtime.RequiredError('databaseField','Required parameter requestParameters.databaseField was null or undefined when calling createField.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dbadmin/databases/{databaseId}/fields`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DatabaseFieldToJSON(requestParameters.databaseField),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DatabaseFieldFromJSON(jsonValue));
    }

    /**
     * create a field
     */
    async createField(requestParameters: CreateFieldRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DatabaseField> {
        const response = await this.createFieldRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * delete all database entries
     * delete all database entries
     */
    async deleteAllDatabaseEntriesRaw(requestParameters: DeleteAllDatabaseEntriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling deleteAllDatabaseEntries.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling deleteAllDatabaseEntries.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dbadmin/databases/{databaseId}/entries`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * delete all database entries
     * delete all database entries
     */
    async deleteAllDatabaseEntries(requestParameters: DeleteAllDatabaseEntriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAllDatabaseEntriesRaw(requestParameters, initOverrides);
    }

    /**
     * Delete content page
     * Delete content page
     */
    async deleteContentPageRaw(requestParameters: DeleteContentPageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling deleteContentPage.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling deleteContentPage.');
        }

        if (requestParameters.pageId === null || requestParameters.pageId === undefined) {
            throw new runtime.RequiredError('pageId','Required parameter requestParameters.pageId was null or undefined when calling deleteContentPage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dbadmin/databases/{databaseId}/content-pages/{pageId}`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))).replace(`{${"pageId"}}`, encodeURIComponent(String(requestParameters.pageId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete content page
     * Delete content page
     */
    async deleteContentPage(requestParameters: DeleteContentPageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteContentPageRaw(requestParameters, initOverrides);
    }

    /**
     * delete database contributor
     * delete database contributor
     */
    async deleteContributorRaw(requestParameters: DeleteContributorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling deleteContributor.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling deleteContributor.');
        }

        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
            throw new runtime.RequiredError('customerId','Required parameter requestParameters.customerId was null or undefined when calling deleteContributor.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dbadmin/databases/{databaseId}/contributors/{customerId}`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))).replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters.customerId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * delete database contributor
     * delete database contributor
     */
    async deleteContributor(requestParameters: DeleteContributorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteContributorRaw(requestParameters, initOverrides);
    }

    /**
     * delete database
     * delete database
     */
    async deleteDatabaseRaw(requestParameters: DeleteDatabaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling deleteDatabase.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling deleteDatabase.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dbadmin/databases/{databaseId}`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * delete database
     * delete database
     */
    async deleteDatabase(requestParameters: DeleteDatabaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteDatabaseRaw(requestParameters, initOverrides);
    }

    /**
     * delete database as superadmin
     * delete database as superadmin
     */
    async deleteDatabaseAsSuperadminRaw(requestParameters: DeleteDatabaseAsSuperadminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling deleteDatabaseAsSuperadmin.');
        }

        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
            throw new runtime.RequiredError('customerId','Required parameter requestParameters.customerId was null or undefined when calling deleteDatabaseAsSuperadmin.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling deleteDatabaseAsSuperadmin.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dbadmin/databases/superadmin/{customerId}/{databaseId}`.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters.customerId))).replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * delete database as superadmin
     * delete database as superadmin
     */
    async deleteDatabaseAsSuperadmin(requestParameters: DeleteDatabaseAsSuperadminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteDatabaseAsSuperadminRaw(requestParameters, initOverrides);
    }

    /**
     * Delete database attachment
     * Delete database attachment
     */
    async deleteDatabaseAttachmentRaw(requestParameters: DeleteDatabaseAttachmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling deleteDatabaseAttachment.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling deleteDatabaseAttachment.');
        }

        if (requestParameters.attachmentId === null || requestParameters.attachmentId === undefined) {
            throw new runtime.RequiredError('attachmentId','Required parameter requestParameters.attachmentId was null or undefined when calling deleteDatabaseAttachment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dbadmin/{databaseId}/attachments/{attachmentId}`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))).replace(`{${"attachmentId"}}`, encodeURIComponent(String(requestParameters.attachmentId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete database attachment
     * Delete database attachment
     */
    async deleteDatabaseAttachment(requestParameters: DeleteDatabaseAttachmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteDatabaseAttachmentRaw(requestParameters, initOverrides);
    }

    /**
     * delete database field
     * delete database field
     */
    async deleteFieldRaw(requestParameters: DeleteFieldRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling deleteField.');
        }

        if (requestParameters.fieldId === null || requestParameters.fieldId === undefined) {
            throw new runtime.RequiredError('fieldId','Required parameter requestParameters.fieldId was null or undefined when calling deleteField.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling deleteField.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dbadmin/databases/{databaseId}/fields/{fieldId}`.replace(`{${"fieldId"}}`, encodeURIComponent(String(requestParameters.fieldId))).replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * delete database field
     * delete database field
     */
    async deleteField(requestParameters: DeleteFieldRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteFieldRaw(requestParameters, initOverrides);
    }

    /**
     * downloads all files uploaded via data fields in database entries (excludes static/header/footer/library files). Super admin only.
     * download all entry files of a database as zip
     */
    async downloadDatabaseFilesRaw(requestParameters: DownloadDatabaseFilesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling downloadDatabaseFiles.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling downloadDatabaseFiles.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dbadmin/databases/{databaseId}/files/download`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * downloads all files uploaded via data fields in database entries (excludes static/header/footer/library files). Super admin only.
     * download all entry files of a database as zip
     */
    async downloadDatabaseFiles(requestParameters: DownloadDatabaseFilesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.downloadDatabaseFilesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get contributors for a database
     * get contributors for a database
     */
    async getContributorsRaw(requestParameters: GetContributorsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DatabaseContributor>>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getContributors.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling getContributors.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dbadmin/databases/{databaseId}/contributors`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DatabaseContributorFromJSON));
    }

    /**
     * get contributors for a database
     * get contributors for a database
     */
    async getContributors(requestParameters: GetContributorsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DatabaseContributor>> {
        const response = await this.getContributorsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get database as excel file
     * get database as excel file
     */
    async getDatabaseAsExcelRaw(requestParameters: GetDatabaseAsExcelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getDatabaseAsExcel.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling getDatabaseAsExcel.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dbadmin/databases/{databaseId}/export`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * get database as excel file
     * get database as excel file
     */
    async getDatabaseAsExcel(requestParameters: GetDatabaseAsExcelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getDatabaseAsExcelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get database children
     * get database children
     */
    async getDatabaseChildrenForAdminRaw(requestParameters: GetDatabaseChildrenForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Database>>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getDatabaseChildrenForAdmin.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling getDatabaseChildrenForAdmin.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dbadmin/databases/{databaseId}/children`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DatabaseFromJSON));
    }

    /**
     * get database children
     * get database children
     */
    async getDatabaseChildrenForAdmin(requestParameters: GetDatabaseChildrenForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Database>> {
        const response = await this.getDatabaseChildrenForAdminRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get database by id
     * get database by id
     */
    async getDatabaseForAdminRaw(requestParameters: GetDatabaseForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Database>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getDatabaseForAdmin.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling getDatabaseForAdmin.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dbadmin/databases/{databaseId}`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DatabaseFromJSON(jsonValue));
    }

    /**
     * get database by id
     * get database by id
     */
    async getDatabaseForAdmin(requestParameters: GetDatabaseForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Database> {
        const response = await this.getDatabaseForAdminRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get all databases
     * get all databases
     */
    async getDatabasesRaw(requestParameters: GetDatabasesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Database>>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getDatabases.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dbadmin/databases`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DatabaseFromJSON));
    }

    /**
     * get all databases
     * get all databases
     */
    async getDatabases(requestParameters: GetDatabasesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Database>> {
        const response = await this.getDatabasesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get field by id
     * get field by id
     */
    async getFieldRaw(requestParameters: GetFieldRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DatabaseField>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getField.');
        }

        if (requestParameters.fieldId === null || requestParameters.fieldId === undefined) {
            throw new runtime.RequiredError('fieldId','Required parameter requestParameters.fieldId was null or undefined when calling getField.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling getField.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dbadmin/databases/{databaseId}/fields/{fieldId}`.replace(`{${"fieldId"}}`, encodeURIComponent(String(requestParameters.fieldId))).replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DatabaseFieldFromJSON(jsonValue));
    }

    /**
     * get field by id
     * get field by id
     */
    async getField(requestParameters: GetFieldRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DatabaseField> {
        const response = await this.getFieldRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get fields by database id
     * get fields by database id
     */
    async getFieldsRaw(requestParameters: GetFieldsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DatabaseField>>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getFields.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling getFields.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dbadmin/databases/{databaseId}/fields`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DatabaseFieldFromJSON));
    }

    /**
     * get fields by database id
     * get fields by database id
     */
    async getFields(requestParameters: GetFieldsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DatabaseField>> {
        const response = await this.getFieldsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the default MJML body template for the given Vorgang, used to prefill the editor when the user clicks \"Vorbelegen\". The MJML files live in `src/main/resources/templates/<folder>/body.mjml`. 
     * get default MJML body for a mail-template type
     */
    async getMailTemplateDefaultRaw(requestParameters: GetMailTemplateDefaultRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getMailTemplateDefault.');
        }

        if (requestParameters.templateType === null || requestParameters.templateType === undefined) {
            throw new runtime.RequiredError('templateType','Required parameter requestParameters.templateType was null or undefined when calling getMailTemplateDefault.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dbadmin/mail-templates/defaults/{templateType}`.replace(`{${"templateType"}}`, encodeURIComponent(String(requestParameters.templateType))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Returns the default MJML body template for the given Vorgang, used to prefill the editor when the user clicks \"Vorbelegen\". The MJML files live in `src/main/resources/templates/<folder>/body.mjml`. 
     * get default MJML body for a mail-template type
     */
    async getMailTemplateDefault(requestParameters: GetMailTemplateDefaultRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getMailTemplateDefaultRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get mail templates for a database
     * get mail templates for a database
     */
    async getMailTemplatesRaw(requestParameters: GetMailTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DatabaseEmailTemplateSpecification>>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getMailTemplates.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling getMailTemplates.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dbadmin/databases/{databaseId}/mail-templates`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DatabaseEmailTemplateSpecificationFromJSON));
    }

    /**
     * get mail templates for a database
     * get mail templates for a database
     */
    async getMailTemplates(requestParameters: GetMailTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DatabaseEmailTemplateSpecification>> {
        const response = await this.getMailTemplatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get permission matrix for a database
     * get permission matrix for a database
     */
    async getPermissionsRaw(requestParameters: GetPermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DatabasePermissionMatrix>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getPermissions.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling getPermissions.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dbadmin/databases/{databaseId}/permissions`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DatabasePermissionMatrixFromJSON(jsonValue));
    }

    /**
     * get permission matrix for a database
     * get permission matrix for a database
     */
    async getPermissions(requestParameters: GetPermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DatabasePermissionMatrix> {
        const response = await this.getPermissionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get quota
     */
    async getQuotaRaw(requestParameters: GetQuotaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DatabasesQuota>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getQuota.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dbadmin/quota`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DatabasesQuotaFromJSON(jsonValue));
    }

    /**
     * get quota
     */
    async getQuota(requestParameters: GetQuotaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DatabasesQuota> {
        const response = await this.getQuotaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get quota as superadmin
     */
    async getQuotaAsSuperadminRaw(requestParameters: GetQuotaAsSuperadminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DatabasesQuota>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getQuotaAsSuperadmin.');
        }

        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
            throw new runtime.RequiredError('customerId','Required parameter requestParameters.customerId was null or undefined when calling getQuotaAsSuperadmin.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dbadmin/quota/superadmin/{customerId}`.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters.customerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DatabasesQuotaFromJSON(jsonValue));
    }

    /**
     * get quota as superadmin
     */
    async getQuotaAsSuperadmin(requestParameters: GetQuotaAsSuperadminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DatabasesQuota> {
        const response = await this.getQuotaAsSuperadminRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * imports excelfile to database
     * import excel to database
     */
    async importExcelToDatabaseRaw(requestParameters: ImportExcelToDatabaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling importExcelToDatabase.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling importExcelToDatabase.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dbadmin/databases/{databaseId}/import`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * imports excelfile to database
     * import excel to database
     */
    async importExcelToDatabase(requestParameters: ImportExcelToDatabaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.importExcelToDatabaseRaw(requestParameters, initOverrides);
    }

    /**
     * partially update database
     * partially update database
     */
    async partiallyUpdateDatabaseRaw(requestParameters: PartiallyUpdateDatabaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Database>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling partiallyUpdateDatabase.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling partiallyUpdateDatabase.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dbadmin/databases/{databaseId}`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: DatabaseToJSON(requestParameters.database),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DatabaseFromJSON(jsonValue));
    }

    /**
     * partially update database
     * partially update database
     */
    async partiallyUpdateDatabase(requestParameters: PartiallyUpdateDatabaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Database> {
        const response = await this.partiallyUpdateDatabaseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * send emails which are related to DatabaseDateFields
     * send emails which are related to DatabaseDateFields
     */
    async sendDatedEmailsRaw(requestParameters: SendDatedEmailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling sendDatedEmails.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling sendDatedEmails.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dbadmin/databases/{databaseId}/dated-emails`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * send emails which are related to DatabaseDateFields
     * send emails which are related to DatabaseDateFields
     */
    async sendDatedEmails(requestParameters: SendDatedEmailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.sendDatedEmailsRaw(requestParameters, initOverrides);
    }

    /**
     * set password for anonymous access
     * set password for anonymous access
     */
    async setAnonymousPasswordRaw(requestParameters: SetAnonymousPasswordOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling setAnonymousPassword.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling setAnonymousPassword.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dbadmin/databases/{databaseId}/anonymousPassword`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SetAnonymousPasswordRequestToJSON(requestParameters.setAnonymousPasswordRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * set password for anonymous access
     * set password for anonymous access
     */
    async setAnonymousPassword(requestParameters: SetAnonymousPasswordOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.setAnonymousPasswordRaw(requestParameters, initOverrides);
    }

    /**
     * set default password for anonymous access
     * set default password for anonymous access
     */
    async setDefaultAnonymousPasswordRaw(requestParameters: SetDefaultAnonymousPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling setDefaultAnonymousPassword.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling setDefaultAnonymousPassword.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dbadmin/databases/{databaseId}/anonymousPassword/setDefault`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * set default password for anonymous access
     * set default password for anonymous access
     */
    async setDefaultAnonymousPassword(requestParameters: SetDefaultAnonymousPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.setDefaultAnonymousPasswordRaw(requestParameters, initOverrides);
    }

    /**
     * updates mail templates
     * updates mail templates
     */
    async setMailTemplatesRaw(requestParameters: SetMailTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DatabaseEmailTemplateSpecification>>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling setMailTemplates.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling setMailTemplates.');
        }

        if (requestParameters.databaseEmailTemplateSpecification === null || requestParameters.databaseEmailTemplateSpecification === undefined) {
            throw new runtime.RequiredError('databaseEmailTemplateSpecification','Required parameter requestParameters.databaseEmailTemplateSpecification was null or undefined when calling setMailTemplates.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dbadmin/databases/{databaseId}/mail-templates`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.databaseEmailTemplateSpecification.map(DatabaseEmailTemplateSpecificationToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DatabaseEmailTemplateSpecificationFromJSON));
    }

    /**
     * updates mail templates
     * updates mail templates
     */
    async setMailTemplates(requestParameters: SetMailTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DatabaseEmailTemplateSpecification>> {
        const response = await this.setMailTemplatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * database adminLocked flag gets toggled
     * toggles the admin locked flag of a database
     */
    async toggleDatabaseAdminLockRaw(requestParameters: ToggleDatabaseAdminLockRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Database>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling toggleDatabaseAdminLock.');
        }

        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
            throw new runtime.RequiredError('customerId','Required parameter requestParameters.customerId was null or undefined when calling toggleDatabaseAdminLock.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling toggleDatabaseAdminLock.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dbadmin/databases/superadmin/{customerId}/{databaseId}/toggle-admin-lock`.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters.customerId))).replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DatabaseFromJSON(jsonValue));
    }

    /**
     * database adminLocked flag gets toggled
     * toggles the admin locked flag of a database
     */
    async toggleDatabaseAdminLock(requestParameters: ToggleDatabaseAdminLockRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Database> {
        const response = await this.toggleDatabaseAdminLockRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * database locked flag gets toggled
     * toggle the locked flag of a database
     */
    async toggleDatabaseLockRaw(requestParameters: ToggleDatabaseLockRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Database>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling toggleDatabaseLock.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling toggleDatabaseLock.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dbadmin/databases/{databaseId}/toggle-lock`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DatabaseFromJSON(jsonValue));
    }

    /**
     * database locked flag gets toggled
     * toggle the locked flag of a database
     */
    async toggleDatabaseLock(requestParameters: ToggleDatabaseLockRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Database> {
        const response = await this.toggleDatabaseLockRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update content page
     * Update content page
     */
    async updateContentPageRaw(requestParameters: UpdateContentPageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DatabaseContentPage>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling updateContentPage.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling updateContentPage.');
        }

        if (requestParameters.pageId === null || requestParameters.pageId === undefined) {
            throw new runtime.RequiredError('pageId','Required parameter requestParameters.pageId was null or undefined when calling updateContentPage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dbadmin/databases/{databaseId}/content-pages/{pageId}`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))).replace(`{${"pageId"}}`, encodeURIComponent(String(requestParameters.pageId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DatabaseContentPageToJSON(requestParameters.databaseContentPage),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DatabaseContentPageFromJSON(jsonValue));
    }

    /**
     * Update content page
     * Update content page
     */
    async updateContentPage(requestParameters: UpdateContentPageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DatabaseContentPage> {
        const response = await this.updateContentPageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * update content page order
     */
    async updateContentPagesOrderRaw(requestParameters: UpdateContentPagesOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling updateContentPagesOrder.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling updateContentPagesOrder.');
        }

        if (requestParameters.requestBody === null || requestParameters.requestBody === undefined) {
            throw new runtime.RequiredError('requestBody','Required parameter requestParameters.requestBody was null or undefined when calling updateContentPagesOrder.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dbadmin/databases/{databaseId}/content-pages`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.requestBody,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * update content page order
     */
    async updateContentPagesOrder(requestParameters: UpdateContentPagesOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.updateContentPagesOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * update database contributor
     * update database contributor
     */
    async updateContributorRaw(requestParameters: UpdateContributorOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling updateContributor.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling updateContributor.');
        }

        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
            throw new runtime.RequiredError('customerId','Required parameter requestParameters.customerId was null or undefined when calling updateContributor.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dbadmin/databases/{databaseId}/contributors/{customerId}`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))).replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters.customerId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateContributorRequestToJSON(requestParameters.updateContributorRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * update database contributor
     * update database contributor
     */
    async updateContributor(requestParameters: UpdateContributorOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateContributorRaw(requestParameters, initOverrides);
    }

    /**
     * update database attachment
     * update database attachment
     */
    async updateDatabaseAttachmentRaw(requestParameters: UpdateDatabaseAttachmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DatabaseEntryFileMetaData>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling updateDatabaseAttachment.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling updateDatabaseAttachment.');
        }

        if (requestParameters.attachmentId === null || requestParameters.attachmentId === undefined) {
            throw new runtime.RequiredError('attachmentId','Required parameter requestParameters.attachmentId was null or undefined when calling updateDatabaseAttachment.');
        }

        if (requestParameters.databaseEntryFileMetaData === null || requestParameters.databaseEntryFileMetaData === undefined) {
            throw new runtime.RequiredError('databaseEntryFileMetaData','Required parameter requestParameters.databaseEntryFileMetaData was null or undefined when calling updateDatabaseAttachment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dbadmin/{databaseId}/attachments/{attachmentId}`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))).replace(`{${"attachmentId"}}`, encodeURIComponent(String(requestParameters.attachmentId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DatabaseEntryFileMetaDataToJSON(requestParameters.databaseEntryFileMetaData),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DatabaseEntryFileMetaDataFromJSON(jsonValue));
    }

    /**
     * update database attachment
     * update database attachment
     */
    async updateDatabaseAttachment(requestParameters: UpdateDatabaseAttachmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DatabaseEntryFileMetaData> {
        const response = await this.updateDatabaseAttachmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * update database field
     * update database field
     */
    async updateFieldRaw(requestParameters: UpdateFieldOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DatabaseField>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling updateField.');
        }

        if (requestParameters.fieldId === null || requestParameters.fieldId === undefined) {
            throw new runtime.RequiredError('fieldId','Required parameter requestParameters.fieldId was null or undefined when calling updateField.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling updateField.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dbadmin/databases/{databaseId}/fields/{fieldId}`.replace(`{${"fieldId"}}`, encodeURIComponent(String(requestParameters.fieldId))).replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateFieldRequestToJSON(requestParameters.updateFieldRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DatabaseFieldFromJSON(jsonValue));
    }

    /**
     * update database field
     * update database field
     */
    async updateField(requestParameters: UpdateFieldOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DatabaseField> {
        const response = await this.updateFieldRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * update fields order
     */
    async updateFieldsOrderRaw(requestParameters: UpdateFieldsOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DatabaseField>>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling updateFieldsOrder.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling updateFieldsOrder.');
        }

        if (requestParameters.requestBody === null || requestParameters.requestBody === undefined) {
            throw new runtime.RequiredError('requestBody','Required parameter requestParameters.requestBody was null or undefined when calling updateFieldsOrder.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dbadmin/databases/{databaseId}/fields`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.requestBody,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DatabaseFieldFromJSON));
    }

    /**
     * update fields order
     */
    async updateFieldsOrder(requestParameters: UpdateFieldsOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DatabaseField>> {
        const response = await this.updateFieldsOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * update database pages
     * update database pages
     */
    async updatePagesRaw(requestParameters: UpdatePagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Database>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling updatePages.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling updatePages.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dbadmin/databases/{databaseId}/pages`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DatabasePagesToJSON(requestParameters.databasePages),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DatabaseFromJSON(jsonValue));
    }

    /**
     * update database pages
     * update database pages
     */
    async updatePages(requestParameters: UpdatePagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Database> {
        const response = await this.updatePagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * update permission matrix for a database
     * update permission matrix for a database
     */
    async updatePermissionsRaw(requestParameters: UpdatePermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DatabasePermissionMatrix>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling updatePermissions.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling updatePermissions.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dbadmin/databases/{databaseId}/permissions`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DatabasePermissionMatrixToJSON(requestParameters.databasePermissionMatrix),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DatabasePermissionMatrixFromJSON(jsonValue));
    }

    /**
     * update permission matrix for a database
     * update permission matrix for a database
     */
    async updatePermissions(requestParameters: UpdatePermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DatabasePermissionMatrix> {
        const response = await this.updatePermissionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Legt eine NEUE Datenbank auf Basis der gewaehlten Designvorlage an und uebertraegt die Datensaetze. Abgewaehlte Felder bleiben leer und ihre Dateien werden nicht kopiert. Der Versandtermin wird auf die naechste Gelegenheit gesetzt. Die bisherige Datenbank bleibt unberuehrt. 
     * Datensaetze in eine neue Datenbank mit anderer Designvorlage uebernehmen
     */
    async vorlagenwechselAusfuehrenRaw(requestParameters: VorlagenwechselAusfuehrenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VorlagenwechselBericht>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling vorlagenwechselAusfuehren.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling vorlagenwechselAusfuehren.');
        }

        if (requestParameters.vorlagenwechselAuftrag === null || requestParameters.vorlagenwechselAuftrag === undefined) {
            throw new runtime.RequiredError('vorlagenwechselAuftrag','Required parameter requestParameters.vorlagenwechselAuftrag was null or undefined when calling vorlagenwechselAusfuehren.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dbadmin/databases/{databaseId}/vorlagenwechsel`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VorlagenwechselAuftragToJSON(requestParameters.vorlagenwechselAuftrag),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VorlagenwechselBerichtFromJSON(jsonValue));
    }

    /**
     * Legt eine NEUE Datenbank auf Basis der gewaehlten Designvorlage an und uebertraegt die Datensaetze. Abgewaehlte Felder bleiben leer und ihre Dateien werden nicht kopiert. Der Versandtermin wird auf die naechste Gelegenheit gesetzt. Die bisherige Datenbank bleibt unberuehrt. 
     * Datensaetze in eine neue Datenbank mit anderer Designvorlage uebernehmen
     */
    async vorlagenwechselAusfuehren(requestParameters: VorlagenwechselAusfuehrenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VorlagenwechselBericht> {
        const response = await this.vorlagenwechselAusfuehrenRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Liefert je Feld der Datenbank, welchem Feld der Ziel-Vorlage es zugeordnet wird — ueber die Template-Rolle, ueber Name und Typ, oder gar nicht (dann wird es angelegt). Aendert NICHTS. Grundlage fuer die Feld-Uebersicht, in der der Benutzer einzelne Felder abwaehlen kann. 
     * Zuordnungs-Vorschau fuer einen Vorlagenwechsel
     */
    async vorlagenwechselVorschauRaw(requestParameters: VorlagenwechselVorschauRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<VorlagenwechselZuordnung>>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling vorlagenwechselVorschau.');
        }

        if (requestParameters.databaseId === null || requestParameters.databaseId === undefined) {
            throw new runtime.RequiredError('databaseId','Required parameter requestParameters.databaseId was null or undefined when calling vorlagenwechselVorschau.');
        }

        if (requestParameters.zielVorlageId === null || requestParameters.zielVorlageId === undefined) {
            throw new runtime.RequiredError('zielVorlageId','Required parameter requestParameters.zielVorlageId was null or undefined when calling vorlagenwechselVorschau.');
        }

        const queryParameters: any = {};

        if (requestParameters.zielVorlageId !== undefined) {
            queryParameters['zielVorlageId'] = requestParameters.zielVorlageId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/dbadmin/databases/{databaseId}/vorlagenwechsel/vorschau`.replace(`{${"databaseId"}}`, encodeURIComponent(String(requestParameters.databaseId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(VorlagenwechselZuordnungFromJSON));
    }

    /**
     * Liefert je Feld der Datenbank, welchem Feld der Ziel-Vorlage es zugeordnet wird — ueber die Template-Rolle, ueber Name und Typ, oder gar nicht (dann wird es angelegt). Aendert NICHTS. Grundlage fuer die Feld-Uebersicht, in der der Benutzer einzelne Felder abwaehlen kann. 
     * Zuordnungs-Vorschau fuer einen Vorlagenwechsel
     */
    async vorlagenwechselVorschau(requestParameters: VorlagenwechselVorschauRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<VorlagenwechselZuordnung>> {
        const response = await this.vorlagenwechselVorschauRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
